import "core-js/modules/es6.object.assign";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import styled from 'styled-components';
import hideVisually from '../../../../theme/shared/hideVisually';
var StyledLink = styled.a.withConfig({
  displayName: "Icon__StyledLink",
  componentId: "no6fx6-0"
})(["text-decoration:none;cursor:pointer;display:block;transition:opacity 0.2s;&:hover,&:focus{opacity:0.6;}}"]);
var StyledImage = styled.img.withConfig({
  displayName: "Icon__StyledImage",
  componentId: "no6fx6-1"
})(["width:100%;"]);
var HelperText = styled.span.withConfig({
  displayName: "Icon__HelperText",
  componentId: "no6fx6-2"
})(["", ";"], hideVisually);

var Icon = function Icon(_ref) {
  var href = _ref.href,
      target = _ref.target,
      icon = _ref.icon,
      brand = _ref.brand,
      title = _ref.title,
      restProps = _objectWithoutProperties(_ref, ["href", "target", "icon", "brand", "title"]);

  return React.createElement(StyledLink, Object.assign({
    href: href,
    target: "_".concat(target)
  }, restProps, {
    title: title,
    rel: "noopener noreferrer"
  }), React.createElement(StyledImage, {
    src: icon,
    alt: brand
  }), title !== 'Sign up for emails' && React.createElement(HelperText, null, "(opens in new window)"));
};

export default Icon;